// imports
import _get from 'lodash/get';
import Config from '$root/Config';
import IncidentModel from '../../models/incidents/IncidentModel';
import MinskyCollection from '../MinskyCollection';

// class definition
export default class IncidentCollection extends MinskyCollection {
	// constructor
	constructor(args = {}) {
		// clone args to do some modifications
		args = Object.assign({}, args);
		args.Model = args.Model || IncidentModel;

		// call super constructor
		super(args);
	}

	fetch(preventClear) {
		this.setConfig('url', `${Config.getUrl('c_incidents')}`);
		return super.fetch(preventClear);
	}

	parse(data) {
		data.data.map(item => {
			const newModel = new this.Model().parse({data: item});
			return newModel;
		});

		return super.parse(data);
	}

	bulkSet(model) {
		// convert to object to avoid any mistakes
		if (model instanceof IncidentModel) model = model.toObject(true);

		// loop over all & apply values
		this.each((_, item) => {
			item.set(model);
		});

		return this;
	}
}
